<p-dialog
  [(visible)]="isVisible"
  [modal]="true"
  [closable]="false"
  styleClass="invite-admins-dialog"
>
  <div class="flex flex-column">
    <div class="text-lg-semibold text-gray-900">Dodaj admina</div>
    <div class="mt-1 text-sm-regular text-gray-600">
      Pozovite nove saradnike da se pridruže sistemu.
    </div>

    <app-field class="mt-4" label="Email adresa" for="invite-email-0">
      <div class="flex flex-column gap-2">
        @for (ctrl of emails.controls; track $index) {
          <div class="flex flex-column gap-1">
            <div class="flex align-items-center gap-2">
              <app-email-input
                class="flex-1"
                [formCtrl]="ctrl | formControl"
                [formCtrlId]="'invite-email-' + $index"
                ctrlPlaceholder="Ukucaj email adresu"
              ></app-email-input>
              @if (emails.length > 1) {
                <app-button
                  [btnSize]="ButtonSize.SM"
                  [btnSeverity]="ButtonSeverity.TERTIARY"
                  [isDestructive]="true"
                  btnClass="icon-only"
                  (btnClicked)="removeEmail($index)"
                >
                  <i class="pi pi-trash"></i>
                </app-button>
              }
            </div>
            @if (ctrl.errors?.['duplicate'] && (ctrl.dirty || ctrl.touched)) {
              <small class="text-error text-xs-regular">
                Ova email adresa je već dodata.
              </small>
            }
          </div>
        }
      </div>
    </app-field>

    <div class="mt-3 inline-action">
      <app-button
        [btnSize]="ButtonSize.SM"
        [btnSeverity]="ButtonSeverity.TERTIARY"
        btnClass="link-action"
        (btnClicked)="addEmail()"
      >
        <i class="pi pi-plus link-action__icon"></i>
        <span class="text-sm-semibold link-action__text">Dodaj još</span>
      </app-button>
    </div>
  </div>

  <ng-template #header>
    <div class="flex align-items-center justify-content-between w-full">
      <div class="flex justify-content-center align-items-center icon">
        <app-users-01 stroke="#414651" width="20px" height="20px"></app-users-01>
      </div>
      <app-x-close
        stroke="#ADB0B8"
        width="12"
        height="12"
        class="cursor-pointer"
        (click)="onCancel()"
      ></app-x-close>
    </div>
  </ng-template>

  <ng-template #footer>
    <div class="mt-2 flex justify-content-end align-items-center w-full">
      <app-button
        [btnSeverity]="ButtonSeverity.SECONDARY"
        [btnSize]="ButtonSize.MD"
        (btnClicked)="onCancel()"
      >
        <div class="text-sm-semibold text-gray-900">Otkaži</div>
      </app-button>
      <app-button
        class="ml-2-5"
        [btnSeverity]="ButtonSeverity.PRIMARY"
        [btnSize]="ButtonSize.MD"
        (btnClicked)="onSubmit()"
      >
        <div class="text-sm-semibold text-white">Dodaj</div>
      </app-button>
    </div>
  </ng-template>
</p-dialog>
